import { render, staticRenderFns } from "./PreregistrationInfo.vue?vue&type=template&id=5aee8f72"
import script from "./PreregistrationInfo.vue?vue&type=script&lang=js"
export * from "./PreregistrationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports